import request from "@/utils/request";

// 下拉获取数据
export function loadAreaDataApi(data) {
  return request({
    url: "web/area/findAreaByCondition",
    method: "post",
    data
  });
}
